import { v4 as uuid } from 'uuid';

const PROXY_ENDPOINT = 'https://proxy.so.cimpress.io';
const TIS_API_ID = 'Jo3pR4S';

async function request(path: string, options?: RequestInit) {
  const response = await fetch(`${PROXY_ENDPOINT}${path}`, options);
  const data = await response.json().catch(() => undefined);

  if (!response.ok) {
    const message =
      (data && data.message) ||
      `Request failed with status code ${response.status}`;

    throw Object.assign(new Error(message), {
      response: { data: data || { message }, status: response.status },
    });
  }

  return data;
}

function apiHeaders(token: string) {
  return {
    token,
    'api-id': TIS_API_ID,
  };
}

/**
 * Calls the proxy service to get a temporary token to be able to call proxy to query
 * statuses of tracking numbers.
 * @param {string} trackingNumber Comma separated list of tracking numbers
 * @public
 */
export async function getTrackInformation(trackingNumber: string) {
  const token = await getRequestToken();

  return request(
    `/api/v1/shipments-status?trackingNumbers=${trackingNumber.replace(
      / /g,
      ''
    )}`,
    { headers: apiHeaders(token) }
  );
}

/**
 * Calls the proxy service to get a temporary token to be able to call proxy to query
 * statuses of tracking numbers.
 * @public
 */
export async function getStatusCodes() {
  const token = await getRequestToken();

  return request('/api/v1/status-codes', { headers: apiHeaders(token) });
}

/**
 * Initializes the token and sets in local storage
 * @public
 */
export async function initToken() {
  const token = uuid();

  await request('/api/v1/token', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token }),
  });

  localStorage.setItem('token', token);
}

export async function getRequestToken() {
  const token = localStorage.getItem('token');

  const data = await request('/api/v1/token', {
    headers: token ? { token } : {},
  });

  if (!data || !data.token) {
    throw new Error('The proxy response did not contain a token');
  }

  localStorage.setItem('token', data.token);

  return data.token;
}
